export const SORT_DIRECTIONS_ASC_DSC = ['ascend', 'descend', 'ascend']
export const ARIAL_14_PX = '14px Arial'
export const POTENTIAL_SELECTION = 'potential_selection'
export const PRODUCT_NAME = 'product_name'
export const MARKET = 'market'
export const NAC = 'nac'
export const CURRENT_MARKET_SHARE = 'current_market_share'
export const POTENTIAL_MARKET_SHARE = 'potential_market_share'
export const LABEL = 'label'
export const DELTA_DOLLAR = 'delta_dollar'
export const DELTA = 'delta'
export const PERCENT_80_WIDTH = 1500
export const PERCENT_90_WIDTH = 1400
export const PERCENT_100_WIDTH = 1200
export const PERCENT_110_WIDTH = 1100
export const PERCENT_125_WIDTH = 1000
